export const SUPPORTED_APP_LOCALES = ["en", "sr"];
export const DEFAULT_APP_LOCALE = "en";
export const SERBIAN_PRIMARY_TAGS = ["sr", "bs", "hr", "cnr", "sh"];
// Application locales stay short for routes and APIs. Presentation locales
// select the regional script used by Intl and a symbolic date-fns import key.
export const APP_LOCALE_PRESENTATION = {
    en: { intlLocale: "en-US", dateFnsLocaleKey: "enUS" },
    sr: { intlLocale: "sr-Latn-RS", dateFnsLocaleKey: "srLatn" },
};
export function isAppLocale(value) {
    return value === "en" || value === "sr";
}
export function normalizeAppLocale(value) {
    if (typeof value !== "string")
        return DEFAULT_APP_LOCALE;
    const language = value.trim().replace(/_/g, "-").split("-", 1)[0]?.toLowerCase();
    return isAppLocale(language) ? language : DEFAULT_APP_LOCALE;
}
export function resolveAppLocale(preferred) {
    // This rule mirrors the API culture resolver; differential tests keep both in parity.
    for (const value of preferred) {
        const language = value.trim().replace(/_/g, "-").split("-", 1)[0]?.toLowerCase();
        if (language === "en")
            return "en";
        if (SERBIAN_PRIMARY_TAGS.includes(language ?? "")) {
            return "sr";
        }
    }
    return DEFAULT_APP_LOCALE;
}
export function resolveAppLocalePresentation(value) {
    return APP_LOCALE_PRESENTATION[normalizeAppLocale(value)];
}
